module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_Italy-EuropeanStu.457ab0a8.jpg";